export { MuiThemeProvider as ThemeProvider } from './MuiThemeProvider';
